import * as React from 'react'
import { SVGProps } from 'react'

const SvgArrowRangeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <g clipPath='url(#arrowRangeIcon_svg__a)' fill='#FFB038'>
      <path d='m12.76 12.251 2.613-2.612a2.388 2.388 0 0 0 0-3.3l-2.612-2.613a1 1 0 0 0-1.414 1.414L13.2 6.993 1.033 7.01a1 1 0 0 0 0 2l12.158-.016-1.844 1.844a.999.999 0 0 0 .703 1.72.999.999 0 0 0 .71-.306Z' />
      <path d='M3.307 12.252.695 9.639a2.389 2.389 0 0 1 0-3.3l2.612-2.613A1 1 0 0 1 4.721 5.14L2.868 6.994l12.167.015a1 1 0 1 1 0 2L2.877 8.994l1.844 1.844a1 1 0 1 1-1.414 1.414Z' />
    </g>
    <defs>
      <clipPath id='arrowRangeIcon_svg__a'>
        <path fill='#fff' d='M0 0h16v16H0z' />
      </clipPath>
    </defs>
  </svg>
)

export default SvgArrowRangeIcon
